import React, { Component } from 'react'
import { connect } from 'react-redux';
import selecionarItemFechamento from '../../actions/fechamento-caixa/selecionarItemFechamento';
import { withRouter } from 'react-router-dom';

class AcoesFechamentoCaixa extends Component {
  vizualizarFechamento () {
    const modal = this.props.history.location.pathname === '/painel-fechamento-caixa-agencia' ? '#modalFechamentoCaixaAgencia' : '#modalFechamentoCaixa';
    return (<a className="dropdown-item" data-toggle="modal" data-target={modal}
               onClick={() => {
                 this.props.selecionarItemFechamento(this.props.item)
               }}> Visualizar Fechamento
    </a>)
  }

  exibirDetalhamento () {
    let url =  `/${this.props.paginaDetalhamento}`;
    if (this.props.seAgencia) {
      url = url + `?fechamento=${this.props.item.id}`;
    } else {
      url = url +`?usuarioEmpresa=${this.props.item.idUsuarioEmpresa}&data=${this.props.item.dataFechamentoSemFormatacao}`;
      if (this.props.item.id) {
        url = url + `&fechamento=${this.props.item.id}`;
      }
    }
    return (
      <div>
        <a className="dropdown-item"
           onClick={() => {
             this.props.history.push(url)
           }}> Exibir Detalhamento
        </a>
      </div>
    )
  }


  render () {
    return (
      <div className="col-lg-1 col-xl-1">
        <div className="dropdown">
          <span className="titulo-mobile">Ações:</span>
          <button className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            <i className="material-icons">
              &#xe5d4;
            </i>

          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {this.vizualizarFechamento()}
            {this.exibirDetalhamento()}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(null, { selecionarItemFechamento })(AcoesFechamentoCaixa))
